/* eslint-disable @tidio/rules/always-require-default-export */
import React, { type ReactElement } from 'react';

export const Bubble = (): ReactElement => (
    <svg
        id="ic_bubble"
        fill="#FFFFFF"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </svg>
);

export const Send = (): ReactElement => (
    <svg
        id="ic_send"
        fill="#FFFFFF"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </svg>
);

export const Close = (): ReactElement => (
    <svg
        id="ic_close"
        fill="#000000"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M5.275 16L4 14.725L8.725 10L4 5.275L5.275 4L10 8.725L14.725 4L16 5.275L11.275 10L16 14.725L14.725 16L10 11.275L5.275 16Z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </svg>
);

export const Options = (): ReactElement => (
    <svg
        id="ic_options"
        className="options-icon"
        fill="#000000"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
);

export const OptionsLight = (): ReactElement => (
    <svg
        id="ic_options"
        className="options-icon"
        fill="#000000"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M11.5 4C11.5 4.82843 10.8284 5.5 10 5.5C9.17157 5.5 8.5 4.82843 8.5 4C8.5 3.17157 9.17157 2.5 10 2.5C10.8284 2.5 11.5 3.17157 11.5 4Z" />
        <path d="M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10Z" />
        <path d="M10 17.5C10.8284 17.5 11.5 16.8284 11.5 16C11.5 15.1716 10.8284 14.5 10 14.5C9.17157 14.5 8.5 15.1716 8.5 16C8.5 16.8284 9.17157 17.5 10 17.5Z" />
    </svg>
);

export const NotificationsOff = (): ReactElement => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.53332 12.3233V11.4568H4.20516V7.14893C4.20516 6.74893 4.27055 6.3652 4.40132 5.99776C4.5321 5.6302 4.70605 5.28448 4.92316 4.96059L7.11149 7.14893H5.85649L1.92316 3.21559L2.54232 2.57976L13.4705 13.5246L12.8513 14.1438L11.0437 12.3233H3.53332ZM11.7948 10.1361L5.75516 4.07976C5.99016 3.89854 6.24443 3.75259 6.51799 3.64193C6.79143 3.53126 7.07432 3.45026 7.36666 3.39893V2.56693C7.36666 2.3917 7.42843 2.24237 7.55199 2.11893C7.67543 1.99537 7.82477 1.93359 7.99999 1.93359C8.17521 1.93359 8.32455 1.99537 8.44799 2.11893C8.57155 2.24237 8.63332 2.3917 8.63332 2.56693V3.39893C9.56066 3.53826 10.3194 3.96176 10.9097 4.66943C11.4998 5.37721 11.7948 6.2037 11.7948 7.14893V10.1361ZM7.99999 14.1951C7.70088 14.1951 7.44749 14.0913 7.23982 13.8836C7.03205 13.6759 6.92816 13.4225 6.92816 13.1233H9.07182C9.07182 13.4225 8.96793 13.6759 8.76016 13.8836C8.55249 14.0913 8.2991 14.1951 7.99999 14.1951Z"
            fill="#080F1A"
        />
    </svg>
);

export const NotificationsOffLight = (): ReactElement => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 15.5V14H5V9C5 8.43056 5.09375 7.88542 5.28125 7.36458C5.46875 6.84375 5.72222 6.35417 6.04167 5.89583L7.14583 7C6.9375 7.29167 6.77778 7.60938 6.66667 7.95312C6.55556 8.29688 6.5 8.64583 6.5 9V14H12L1.875 3.875L2.9375 2.79167L17.0625 16.9375L16 18L13.5 15.5H4ZM15 12.75L13.5 11.25V9C13.5 8.02778 13.1597 7.20139 12.4792 6.52083C11.7986 5.84028 10.9722 5.5 10 5.5C9.68278 5.5 9.37778 5.54167 9.085 5.625C8.79222 5.70833 8.50694 5.82639 8.22917 5.97917L7.14583 4.88521C7.42361 4.68396 7.71875 4.52083 8.03125 4.39583C8.34375 4.27083 8.66667 4.17361 9 4.10417V3C9 2.72222 9.09722 2.48611 9.29167 2.29167C9.48611 2.09722 9.72222 2 10 2C10.2778 2 10.5139 2.09722 10.7083 2.29167C10.9028 2.48611 11 2.72222 11 3V4.10417C12.1806 4.32639 13.1424 4.89583 13.8854 5.8125C14.6285 6.72917 15 7.79167 15 9V12.75ZM9.99563 18C9.58188 18 9.22917 17.8531 8.9375 17.5594C8.64583 17.2656 8.5 16.9125 8.5 16.5H11.5C11.5 16.9167 11.3527 17.2708 11.0581 17.5625C10.7635 17.8542 10.4094 18 9.99563 18Z" />
    </svg>
);

export const EmojiSwitch = (): ReactElement => (
    <svg
        id="ic_emojiSwitch"
        fill="#000000"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12.0006 17.5C14.3306 17.5 16.3106 16.04 17.1106 14L6.89062 14C7.69063 16.04 9.67063 17.5 12.0006 17.5Z"
        />
    </svg>
);

export const AttachFile = (): ReactElement => (
    <svg
        id="ic_attachFile"
        fill="#000000"
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        aria-hidden
    >
        <path fill="none" d="M0,0h24v24H0V0z" />
        <path d="M12.5 22C9.46 22 7 19.54 7 16.5L7 6C7 3.79 8.79 2 11 2C13.21 2 15 3.79 15 6L15 14.5C15 15.88 13.88 17 12.5 17C11.12 17 10 15.88 10 14.5L10 7L12 7L12 14.59C12 15.14 13 15.14 13 14.59L13 6C13 4.9 12.1 4 11 4C9.9 4 9 4.9 9 6L9 16.5C9 18.43 10.57 20 12.5 20C14.43 20 16 18.43 16 16.5L16 7H18L18 16.5C18 19.54 15.54 22 12.5 22Z" />
    </svg>
);

export const NotificationsOn = (): ReactElement => (
    <svg
        id="ic_notificationsOn"
        fill="#000000"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z" />
    </svg>
);

export const NotificationsOnLight = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path d="M2.51291 8.92791C2.51291 7.86055 2.71131 6.87444 3.10812 5.96958C3.50506 5.06472 4.0636 4.26132 4.78374 3.55937L5.6377 4.24041C5.00631 4.82694 4.50819 5.52486 4.14333 6.33416C3.7786 7.14347 3.59624 8.00805 3.59624 8.92791H2.51291ZM16.4037 8.92791C16.4037 7.99416 16.2214 7.12132 15.8567 6.30937C15.4918 5.49743 14.9867 4.79812 14.3415 4.21146L15.2162 3.51771C15.9225 4.20576 16.4776 5.01396 16.8815 5.94229C17.2852 6.87076 17.4871 7.86597 17.4871 8.92791H16.4037ZM4.41666 15.4037V14.3206H5.25645V8.93583C5.25645 7.75958 5.62666 6.73048 6.36708 5.84854C7.10735 4.96659 8.05444 4.43319 9.20833 4.24833V3.20833C9.20833 2.9893 9.28555 2.80264 9.43999 2.64833C9.5943 2.49389 9.78096 2.41666 9.99999 2.41666C10.219 2.41666 10.4057 2.49389 10.56 2.64833C10.7144 2.80264 10.7917 2.9893 10.7917 3.20833V4.24833C11.9455 4.43319 12.8926 4.96659 13.6329 5.84854C14.3733 6.73048 14.7435 7.75958 14.7435 8.93583V14.3206H15.5833V15.4037H4.41666ZM9.99562 17.7435C9.62465 17.7435 9.30937 17.6127 9.04978 17.351C8.79006 17.0894 8.6602 16.7736 8.6602 16.4037H11.3398C11.3398 16.7778 11.2085 17.0946 10.9458 17.3542C10.6833 17.6137 10.3666 17.7435 9.99562 17.7435ZM6.33978 14.3206H13.6602V8.93583C13.6602 7.91555 13.3053 7.05048 12.5954 6.34062C11.8854 5.63062 11.0203 5.27562 9.99999 5.27562C8.97971 5.27562 8.11458 5.63062 7.40458 6.34062C6.69472 7.05048 6.33978 7.91555 6.33978 8.93583V14.3206Z" />
    </svg>
);

export const Arrow = (): ReactElement => (
    <svg
        id="ic_arrow"
        fill="#000000"
        height={24}
        viewBox="0 0 24 24"
        width={24}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </svg>
);

const caretPathInlineStyle = { transform: 'scale(0.8) translate(3px, 4px)' };
export const Caret = (): ReactElement => (
    <svg
        id="caret"
        fill="#000000"
        height="48"
        viewBox="0 0 24 24"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            style={caretPathInlineStyle}
            d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
            fill="#062B2B"
        />
        <path d="M0-.75h24v24H0z" fill="none" />
    </svg>
);

export const SuccessCheck = (): ReactElement => (
    <svg
        id="ic_successChek"
        fill="#000000"
        height="18"
        viewBox="0 0 24 24"
        width="18"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
);

export const ThumbDown = (): ReactElement => (
    <svg
        id="ic_thumbDown"
        fill="#000000"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z" />
    </svg>
);

export const ThumbDownOutlined = (): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={24}
        viewBox="0 0 24 24"
        width={24}
        fill="#000000"
    >
        <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none" />
        <path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z" />
    </svg>
);

export const ThumbUp = (): ReactElement => (
    <svg
        id="ic_thumbUp"
        fill="#000000"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z" />
    </svg>
);

export const ThumbUpOutlined = (): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={24}
        viewBox="0 0 24 24"
        width={24}
        fill="#000000"
    >
        <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none" />
        <path d="M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z" />
    </svg>
);

export const Download = (): ReactElement => (
    <svg
        id="ic_download"
        fill="#000000"
        height={24}
        viewBox="0 0 24 24"
        width={24}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
    </svg>
);

export const UploadIcon = (): ReactElement => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="ic_upload"
    >
        <path d="M7.58341 23.3334C5.81397 23.3334 4.30216 22.7209 3.048 21.4959C1.79383 20.2709 1.16675 18.7737 1.16675 17.0042C1.16675 15.4876 1.62369 14.1362 2.53758 12.9501C3.45147 11.764 4.6473 11.0056 6.12508 10.6751C6.61119 8.88619 7.58341 7.43758 9.04175 6.32925C10.5001 5.22091 12.1529 4.66675 14.0001 4.66675C16.2751 4.66675 18.2049 5.45911 19.7897 7.04383C21.3744 8.62855 22.1667 10.5584 22.1667 12.8334C23.5084 12.989 24.6216 13.5674 25.5063 14.5688C26.3911 15.5702 26.8334 16.7417 26.8334 18.0834C26.8334 19.5417 26.323 20.7813 25.3022 21.8022C24.2813 22.823 23.0417 23.3334 21.5834 23.3334H15.1667C14.5251 23.3334 13.9758 23.1049 13.5188 22.648C13.0619 22.1911 12.8334 21.6417 12.8334 21.0001V14.9917L10.9667 16.8001L9.33342 15.1667L14.0001 10.5001L18.6667 15.1667L17.0334 16.8001L15.1667 14.9917V21.0001H21.5834C22.4001 21.0001 23.0904 20.7181 23.6542 20.1542C24.2181 19.5904 24.5001 18.9001 24.5001 18.0834C24.5001 17.2667 24.2181 16.5765 23.6542 16.0126C23.0904 15.4487 22.4001 15.1667 21.5834 15.1667H19.8334V12.8334C19.8334 11.2195 19.2647 9.84383 18.1272 8.70633C16.9897 7.56883 15.614 7.00008 14.0001 7.00008C12.3862 7.00008 11.0105 7.56883 9.873 8.70633C8.7355 9.84383 8.16675 11.2195 8.16675 12.8334H7.58341C6.45564 12.8334 5.49314 13.232 4.69591 14.0292C3.89869 14.8265 3.50008 15.789 3.50008 16.9167C3.50008 18.0445 3.89869 19.007 4.69591 19.8042C5.49314 20.6015 6.45564 21.0001 7.58341 21.0001H10.5001V23.3334H7.58341Z" />
    </svg>
);

export const NewSkinUploadIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
        <path
            d="M30.2671 41.0363V17.5696L23.6265 24.2103L21.1491 21.7849L32.0005 10.9336L42.8518 21.7849L40.3745 24.2103L33.7338 17.5696V41.0363H30.2671ZM18.4025 49.8669C17.2011 49.8669 16.1893 49.4525 15.3671 48.6236C14.5449 47.7947 14.1338 46.78 14.1338 45.5796V41.5489H17.6005V45.5796C17.6005 45.7849 17.686 45.9729 17.8571 46.1436C18.0278 46.3147 18.2158 46.4003 18.4211 46.4003H45.5798C45.7851 46.4003 45.9731 46.3147 46.1438 46.1436C46.3149 45.9729 46.4005 45.7849 46.4005 45.5796V41.5489H49.8671V45.5796C49.8671 46.78 49.4525 47.7947 48.6231 48.6236C47.7938 49.4525 46.7785 49.8669 45.5771 49.8669H18.4025Z"
            fill="#0566FF"
        />
    </svg>
);

export const PoweredByLyroLogo = (): ReactElement => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 171 18">
        <g fill="#647491">
            <path d="M.9 13V5.727h2.458c.57 0 1.037.103 1.399.31.364.203.634.479.81.827.175.348.262.736.262 1.164s-.087.818-.263 1.169c-.172.35-.44.63-.802.838-.362.206-.826.309-1.392.309H1.61v-.781h1.733c.391 0 .705-.068.941-.203.237-.135.409-.317.515-.547.11-.232.164-.493.164-.785s-.055-.551-.164-.78c-.106-.23-.279-.41-.518-.54-.24-.133-.556-.2-.952-.2H1.781V13zm12.484-3.636c0 .767-.138 1.43-.415 1.988-.277.559-.657.99-1.14 1.293-.483.303-1.035.454-1.655.454-.62 0-1.172-.151-1.655-.454-.483-.303-.863-.734-1.14-1.293s-.415-1.221-.415-1.988c0-.767.138-1.43.415-1.989s.657-.99 1.14-1.293c.483-.303 1.035-.454 1.655-.454.62 0 1.172.151 1.655.454.483.303.863.734 1.14 1.293.277.559.415 1.222.415 1.989zm-.852 0c0-.63-.105-1.162-.316-1.595-.208-.433-.491-.76-.849-.983a2.2 2.2 0 0 0-1.193-.334c-.44 0-.84.111-1.197.334-.355.222-.638.55-.848.983-.209.433-.313.965-.313 1.595s.104 1.16.313 1.594c.21.433.493.761.848.984.358.222.757.334 1.197.334.44 0 .838-.112 1.193-.334.358-.223.64-.55.849-.984.21-.433.316-.965.316-1.594zM16.186 13l-1.989-7.273h.895l1.52 5.924h.071l1.549-5.924h.994l1.548 5.924h.071l1.52-5.924h.895L21.27 13h-.909l-1.605-5.795H18.7L17.095 13zm8.171 0V5.727h4.39v.782h-3.51v2.457h3.282v.781h-3.281v2.472h3.565V13zm5.977 0V5.727h2.457c.568 0 1.035.097 1.4.291.364.192.634.456.809.792.175.337.263.719.263 1.147 0 .429-.088.809-.263 1.14s-.444.592-.806.782c-.362.187-.825.28-1.389.28h-1.988v-.795h1.96c.388 0 .7-.057.938-.17.239-.114.411-.275.518-.484a1.62 1.62 0 0 0 .163-.753c0-.29-.054-.545-.163-.763s-.283-.386-.522-.504c-.24-.121-.555-.181-.948-.181h-1.548V13zm3.423-3.267L35.547 13h-1.023l-1.761-3.267zM36.73 13V5.727h4.39v.782H37.61v2.457h3.281v.781h-3.281v2.472h3.565V13zm8.221 0h-2.244V5.727h2.344c.705 0 1.309.146 1.81.437a2.86 2.86 0 0 1 1.155 1.247c.267.54.401 1.186.401 1.938 0 .758-.135 1.41-.405 1.957-.27.545-.663.964-1.179 1.257-.516.291-1.143.437-1.882.437zm-1.364-.781h1.307c.602 0 1.1-.116 1.495-.348.396-.232.69-.563.885-.991s.29-.939.29-1.53c0-.588-.095-1.093-.287-1.517a2.122 2.122 0 0 0-.86-.98c-.38-.23-.855-.344-1.423-.344h-1.406zm9.12.781V5.727h2.542c.507 0 .925.088 1.254.263.33.173.574.406.735.7.161.29.242.614.242.97 0 .312-.056.57-.167.773a1.298 1.298 0 0 1-.434.483c-.177.119-.37.206-.578.263v.071c.222.014.446.092.67.234.226.142.414.346.565.611.152.265.228.59.228.973 0 .365-.083.693-.249.984-.166.291-.427.522-.785.692-.357.17-.822.256-1.395.256zm.88-.781h1.748c.575 0 .983-.111 1.225-.334a1.07 1.07 0 0 0 .366-.817c0-.246-.063-.473-.189-.682a1.362 1.362 0 0 0-.536-.504 1.682 1.682 0 0 0-.824-.192h-1.79zm0-3.296h1.634c.265 0 .504-.052.717-.156.216-.104.386-.25.512-.44.128-.19.192-.412.192-.668 0-.32-.112-.59-.334-.813-.223-.225-.576-.337-1.058-.337h-1.662zm4.999-3.196h1.008l2.017 3.395h.086l2.017-3.395h1.008l-2.628 4.276V13h-.88v-2.997z" />
            <path
                d="M68.95 17v.05h5.757c2.597 0 4.846-1.756 5.536-4.29l4.344-.015h.05V6.828C84.613 3.59 82.034.95 78.875.95c-1.307 0-2.59.463-3.604 1.3a5.894 5.894 0 0 0-1.973 3.175c-2.57.66-4.348 2.992-4.348 5.728zm9.94-4.26h.067c-.663 1.828-2.333 3.034-4.255 3.034h-4.528v-4.641c0-1.946 1.205-3.69 2.963-4.355V6.863c.015 3.238 2.594 5.878 5.752 5.878zm-4.183-7.5H74.611c.65-1.804 2.356-3.038 4.25-3.038 2.491 0 4.528 2.075 4.542 4.626v4.655h-2.96c.009-.124.016-.248.016-.365 0-3.238-2.58-5.878-5.752-5.878zm-.36 1.617c0-.111.008-.23.016-.348.118-.009.231-.017.344-.017h.014c2.482 0 4.514 2.076 4.528 4.627 0 .119-.007.242-.016.364h-.344c-2.49 0-4.527-2.075-4.542-4.626z"
                stroke="#647491"
                strokeWidth=".1"
            />
            <path d="M89.573 13V5.168h1.419v6.666h3.652V13zm6.573 0V9.48l.297.858-3.476-5.17h1.617l2.475 3.85h-.407l2.475-3.85h1.617l-3.465 5.17.286-.858V13zm4.905 0V5.168h3.355c.887 0 1.562.194 2.024.583s.693.946.693 1.672c0 .69-.239 1.24-.715 1.65-.477.403-1.141.605-1.991.605l.88-.176c.271 0 .513.08.726.242.212.161.381.41.506.748l.968 2.508h-1.496l-.99-2.607c-.103-.257-.25-.429-.44-.517a1.604 1.604 0 0 0-.693-.132h-1.43V13zm1.386-4.356h1.771c.542 0 .938-.099 1.188-.297.249-.198.374-.495.374-.891 0-.403-.125-.7-.374-.891-.25-.19-.646-.286-1.188-.286h-1.771zm9.65 4.444c-.763 0-1.423-.161-1.98-.484a3.22 3.22 0 0 1-1.287-1.386c-.301-.601-.451-1.313-.451-2.134 0-.829.15-1.54.451-2.134a3.22 3.22 0 0 1 1.287-1.386c.557-.323 1.217-.484 1.98-.484.77 0 1.433.161 1.991.484.557.323.986.785 1.287 1.386.3.594.451 1.302.451 2.123 0 .829-.154 1.544-.462 2.145a3.232 3.232 0 0 1-1.287 1.386c-.55.323-1.21.484-1.98.484zm0-1.122c.718 0 1.283-.246 1.694-.737.41-.499.616-1.217.616-2.156 0-.939-.206-1.65-.616-2.134-.411-.491-.976-.737-1.694-.737-.712 0-1.273.246-1.683.737-.411.484-.616 1.195-.616 2.134 0 .939.205 1.657.616 2.156.41.491.971.737 1.683.737zM120.65 13h-1.43l3.542-7.832h1.155L127.459 13h-1.408l-2.882-6.732h.385zm.132-1.837.539-1.1h3.993l.517 1.1zM128.197 13V5.168h1.419V13zm6.507 0h-1.43l3.542-7.832h1.155L141.513 13h-1.408l-2.882-6.732h.385zm.132-1.837.539-1.1h3.993l.517 1.1zm10.852 1.925c-.814 0-1.518-.158-2.112-.473a3.313 3.313 0 0 1-1.353-1.375c-.308-.601-.462-1.324-.462-2.167 0-.829.154-1.54.462-2.134a3.244 3.244 0 0 1 1.342-1.375c.58-.323 1.265-.484 2.057-.484.55 0 1.064.077 1.54.231.477.154.88.381 1.21.682l-.484 1.034a4.037 4.037 0 0 0-1.089-.616 3.265 3.265 0 0 0-1.155-.198c-.799 0-1.408.242-1.826.726-.41.484-.616 1.195-.616 2.134 0 .96.213 1.687.638 2.178.426.484 1.06.726 1.903.726.323 0 .638-.026.946-.077.316-.059.613-.14.891-.242l-.33.528V9.788h-1.683V8.765h2.97v3.762c-.242.125-.517.227-.825.308s-.634.143-.979.187a8.236 8.236 0 0 1-1.045.066zm4.348-.088V5.168h5.236v1.111h-3.85v2.178h3.63v1.122h-3.63v2.31h3.85V13zm6.432 0V5.168h1.056l4.51 5.863-.297.154V5.168h1.331V13h-1.067l-4.488-5.841.286-.176V13zm10.031 0V6.334h-2.552V5.168h6.534v1.166h-2.552V13z" />
        </g>
    </svg>
);

export const PoweredByTidioLogo = (): ReactElement => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden viewBox="0 0 119 18">
        <path
            d="M.9 13V5.727h2.458c.57 0 1.037.103 1.399.31.364.203.634.479.81.827.175.348.262.736.262 1.164 0 .429-.087.818-.263 1.169-.172.35-.44.63-.802.838-.362.206-.826.309-1.392.309H1.61v-.781h1.733c.391 0 .705-.068.941-.203.237-.135.409-.317.515-.547.11-.232.164-.493.164-.785 0-.29-.055-.551-.164-.78-.106-.23-.279-.41-.518-.54-.24-.133-.556-.2-.952-.2H1.781V13H.9Zm12.484-3.636c0 .767-.138 1.43-.415 1.988-.277.559-.657.99-1.14 1.293-.483.303-1.035.454-1.655.454-.62 0-1.172-.151-1.655-.454-.483-.303-.863-.734-1.14-1.293-.277-.558-.415-1.221-.415-1.988 0-.767.138-1.43.415-1.989.277-.559.657-.99 1.14-1.293.483-.303 1.035-.454 1.655-.454.62 0 1.172.151 1.655.454.483.303.863.734 1.14 1.293.277.559.415 1.222.415 1.989Zm-.852 0c0-.63-.105-1.162-.316-1.595-.208-.433-.491-.761-.849-.983a2.2 2.2 0 0 0-1.193-.334c-.44 0-.84.111-1.197.334-.355.222-.638.55-.848.983-.209.433-.313.965-.313 1.595s.104 1.16.313 1.594c.21.433.493.761.848.984.358.222.757.334 1.197.334.44 0 .838-.112 1.193-.334.358-.223.64-.55.849-.984.21-.433.316-.965.316-1.594ZM16.186 13l-1.989-7.273h.895l1.52 5.924h.071l1.549-5.924h.994l1.548 5.924h.071l1.52-5.924h.895L21.27 13h-.909l-1.605-5.795H18.7L17.095 13h-.909Zm8.171 0V5.727h4.39v.782h-3.51v2.457h3.282v.781h-3.281v2.472h3.565V13h-4.446Zm5.977 0V5.727h2.457c.568 0 1.035.097 1.4.291.364.192.634.456.809.792.175.337.263.719.263 1.147 0 .429-.088.809-.263 1.14a1.852 1.852 0 0 1-.806.782c-.362.187-.825.28-1.389.28h-1.988v-.795h1.96c.388 0 .7-.057.938-.17.239-.114.411-.275.518-.484a1.62 1.62 0 0 0 .163-.753c0-.29-.054-.545-.163-.763a1.114 1.114 0 0 0-.522-.504c-.24-.121-.555-.181-.948-.181h-1.548V13h-.881Zm3.423-3.267L35.547 13h-1.023l-1.761-3.267h.994ZM36.73 13V5.727h4.39v.782H37.61v2.457h3.281v.781h-3.281v2.472h3.565V13H36.73Zm8.221 0h-2.244V5.727h2.344c.705 0 1.309.146 1.81.437a2.86 2.86 0 0 1 1.155 1.247c.267.54.401 1.186.401 1.938 0 .758-.135 1.41-.405 1.957-.27.545-.663.964-1.179 1.257-.516.291-1.143.437-1.882.437Zm-1.364-.781h1.307c.602 0 1.1-.116 1.495-.348.396-.232.69-.563.885-.991.194-.429.29-.939.29-1.53 0-.588-.095-1.093-.287-1.517a2.122 2.122 0 0 0-.86-.98c-.38-.23-.855-.344-1.423-.344h-1.407v5.71Zm9.12.781V5.727h2.542c.507 0 .925.088 1.254.263.33.173.574.406.735.7.161.29.242.614.242.97 0 .312-.056.57-.167.773a1.298 1.298 0 0 1-.434.483c-.177.119-.37.206-.578.263v.071c.222.014.446.092.67.234.226.142.414.346.565.611.152.265.228.59.228.973 0 .365-.083.693-.249.984-.166.291-.427.522-.785.692-.357.17-.822.256-1.395.256h-2.628Zm.88-.781h1.748c.575 0 .983-.111 1.225-.334a1.07 1.07 0 0 0 .366-.817c0-.246-.063-.473-.189-.682a1.362 1.362 0 0 0-.536-.504 1.682 1.682 0 0 0-.824-.192h-1.79v2.529Zm0-3.296h1.634c.265 0 .504-.052.717-.156.216-.104.386-.25.512-.44.128-.19.191-.412.191-.668 0-.32-.11-.59-.333-.813-.223-.225-.576-.337-1.059-.337h-1.662v2.414Zm4.999-3.196h1.008l2.017 3.395h.086l2.017-3.395h1.008l-2.628 4.276V13h-.88v-2.997l-2.628-4.276Z"
            fill="#647491"
        />
        <path
            d="M68.95 17v.05h5.757c2.597 0 4.846-1.756 5.536-4.29l4.344-.015h.05V6.828C84.613 3.59 82.034.95 78.875.95c-1.307 0-2.59.463-3.604 1.3a5.894 5.894 0 0 0-1.973 3.175c-2.57.66-4.348 2.992-4.348 5.728V17Zm9.94-4.26h.067c-.663 1.828-2.333 3.034-4.255 3.034h-4.528v-4.641c0-1.946 1.205-3.69 2.963-4.355V6.863c.015 3.238 2.594 5.878 5.752 5.878Zm-4.183-7.5H74.611c.65-1.804 2.356-3.038 4.25-3.038 2.491 0 4.528 2.075 4.542 4.626v4.655h-2.96c.009-.123.016-.248.016-.365 0-3.238-2.58-5.878-5.752-5.878Zm-.36 1.617c0-.111.008-.23.016-.348.118-.009.231-.017.344-.017h.014c2.482 0 4.514 2.076 4.528 4.627 0 .119-.007.242-.016.364h-.344c-2.49 0-4.527-2.075-4.542-4.626Z"
            fill="#647491"
            stroke="#647491"
            strokeWidth=".1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M114.667 13.34a4.23 4.23 0 0 1-3.084-1.242c-1.667-1.715-1.667-4.481 0-6.196a4.19 4.19 0 0 1 3.084-1.242 4.255 4.255 0 0 1 3.083 1.242c1.667 1.715 1.667 4.481 0 6.196a4.254 4.254 0 0 1-3.083 1.242Zm0-7.455a2.6 2.6 0 0 0-2.017.92A3.218 3.218 0 0 0 111.833 9a3.1 3.1 0 0 0 .817 2.179 2.685 2.685 0 0 0 2.017.918c.769 0 1.502-.333 2.016-.918a3.337 3.337 0 0 0 0-4.375 2.6 2.6 0 0 0-2.016-.919Zm-23.534 7.37V6.072h-2.466V4.83h6.416v1.242H92.6v7.183h-1.467ZM99.1 4.83v8.425h2.733c1.6 0 2.784-.374 3.55-1.14.767-.766 1.15-1.804 1.15-3.115 0-1.31-.383-2.332-1.166-3.064-.784-.732-1.934-1.106-3.417-1.106H99.1Zm2.95 7.149h-1.467v-5.89h1.317c1.05 0 1.85.239 2.367.766.516.528.783 1.26.783 2.196 0 .936-.25 1.685-.783 2.179-.534.493-1.267.749-2.217.749Zm-6.067-5.396c-.005-.863.614-1.597 1.45-1.72h.017v6.656c.005.863-.614 1.597-1.45 1.72h-.017V6.582Zm13.184-1.72a1.713 1.713 0 0 0-1.45 1.72v6.655h.016c.836-.122 1.455-.856 1.45-1.719V4.864h-.016Z"
            fill="#647491"
        />
    </svg>
);

export const Xls = (): ReactElement => (
    <svg
        id="xls-xlsx-csv-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#xls-xlsx-csv-icon .cls-1{fill:#208549;}#xls-xlsx-csv-icon .cls-2{fill:#21a558;}#xls-xlsx-csv-icon .cls-3{fill:#2abc65;}#xls-xlsx-csv-icon .cls-4{fill:#fff;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-3" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            className="cls-4"
            d="M10.54,11.79l-3-4.36h2.53L12,10.63l1.87-3.2h2.44l-2.95,4.32,3.3,4.82H14.13L11.9,12.89,9.73,16.57H7.34Z"
        />
    </svg>
);

export const Wma = (): ReactElement => (
    <svg
        id="wma-mp3-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#wma-mp3-icon .cls-1{fill:#542c74;}#wma-mp3-icon .cls-2{fill:#683695;}#wma-mp3-icon .cls-3{fill:#7649a2;}#wma-mp3-icon .cls-4{fill:#fff;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-3" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            className="cls-4"
            d="M12,6.83v6.06a2.26,2.26,0,0,0-1.15-.32,2.3,2.3,0,1,0,2.3,2.3V9.13h2.3V6.83Z"
        />
    </svg>
);

export const Txt = (): ReactElement => (
    <svg
        id="txt-rtf-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#txt-rtf-icon .cls-1{fill:#dadada;}#txt-rtf-icon .cls-2{fill:#fff;}#txt-rtf-icon .cls-3{fill:#445b70;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-2" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            className="cls-3"
            d="M13.54,14H10.31l-.51.8-.58.89a2.12,2.12,0,0,0-.22.51.88.88,0,0,0,0,.36.61.61,0,0,0,.26.34,1.42,1.42,0,0,0,.68.18l.05.28H6.86l0-.28a1.66,1.66,0,0,0,.69-.29,6.59,6.59,0,0,0,1-1.27l5.83-8.82h.35l1.16,8.53c.06.45.1.72.11.81a1.38,1.38,0,0,0,.35.76,1.22,1.22,0,0,0,.75.28l0,.28H12.6l0-.28a4,4,0,0,0,.75-.11.76.76,0,0,0,.31-.45,2.85,2.85,0,0,0,0-1.19Zm-.11-.63L13,9.94l-2.3,3.4Z"
        />
    </svg>
);

export const Pdf = (): ReactElement => (
    <svg
        id="pdf-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#pdf-icon .cls-1{fill:#b6241e;}#pdf-icon .cls-2{fill:#ee2a24;}#pdf-icon .cls-3{fill:#ff4343;}#pdf-icon .cls-4{fill:#fff;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-3" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            className="cls-4"
            d="M18.37,14.46c-.31-.56-1.39-.73-1.89-.81a7.84,7.84,0,0,0-1.19-.08c-.31,0-.61,0-.92,0l-.33,0c-.11-.12-.22-.24-.32-.37a11.45,11.45,0,0,1-1.66-2.63,10.5,10.5,0,0,0,.27-1.42,5.89,5.89,0,0,0-.2-2.77c-.12-.3-.43-.66-.78-.48a1.44,1.44,0,0,0-.56,1.2,3.71,3.71,0,0,0,.05,1,6.15,6.15,0,0,0,.25,1c.09.29.19.57.3.85-.07.23-.14.44-.22.66-.19.48-.39.94-.58,1.39l-.3.64c-.31.68-.64,1.34-1,2A11,11,0,0,0,7,15.73a4.89,4.89,0,0,0-.92.74,1.6,1.6,0,0,0-.51.94.6.6,0,0,0,.24.53,1,1,0,0,0,.81.11,4.46,4.46,0,0,0,2.13-1.58A16.23,16.23,0,0,0,10,14.79h0a19.15,19.15,0,0,1,2.63-.62c.42-.07.86-.13,1.31-.17a7.21,7.21,0,0,0,1,.79,4.87,4.87,0,0,0,.92.44,8,8,0,0,0,1,.25,3,3,0,0,0,.52,0c.4,0,1-.16,1-.65A.66.66,0,0,0,18.37,14.46Zm-9.53.89c-.19.29-.37.55-.53.78a3.88,3.88,0,0,1-1.58,1.48,1.17,1.17,0,0,1-.48.09c-.16,0-.32-.08-.32-.27a.93.93,0,0,1,.13-.33,1.72,1.72,0,0,1,.28-.37,5.06,5.06,0,0,1,.84-.68A10.18,10.18,0,0,1,9,15.17ZM11.18,8.1a3.4,3.4,0,0,1,0-.9,2.59,2.59,0,0,1,.09-.42c0-.12.12-.4.25-.43s.27.39.29.51a5.65,5.65,0,0,1-.14,2.24l-.09.33c-.05-.14-.09-.28-.14-.42A7.13,7.13,0,0,1,11.18,8.1Zm1.44,5.7a22.51,22.51,0,0,0-2.24.49,5.43,5.43,0,0,0,.56-.9,11.61,11.61,0,0,0,1-2.26,10.73,10.73,0,0,0,1.56,2.34,1.54,1.54,0,0,0,.17.19Zm5.3,1c0,.15-.36.24-.51.27A2.94,2.94,0,0,1,16,14.94a4,4,0,0,1-.86-.4A4.79,4.79,0,0,1,14.4,14c.29,0,.59,0,.89,0s.6,0,.9.06a3.2,3.2,0,0,1,1.63.62C17.91,14.69,17.93,14.75,17.92,14.81Z"
        />
    </svg>
);

export const Mpg = (): ReactElement => (
    <svg
        id="mpg-mp4-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#mpg-mp4-icon .cls-1{fill:#132b40;}#mpg-mp4-icon .cls-2{fill:#1c3c57;}#mpg-mp4-icon .cls-3{fill:#335268;}#mpg-mp4-icon .cls-4{fill:#fff;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-3" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            className="cls-4"
            d="M14.69,11.19V9.31a.54.54,0,0,0-.54-.54H7.69a.54.54,0,0,0-.53.54v5.38a.54.54,0,0,0,.53.54h6.46a.54.54,0,0,0,.54-.54V12.81L16.84,15V9Z"
        />
    </svg>
);

export const Flv = (): ReactElement => (
    <svg
        id="flv-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#flv-icon .cls-1{fill:#9b1c24;}#flv-icon .cls-2{fill:#cf1f26;}#flv-icon .cls-3{fill:#f23341;}#flv-icon .cls-4{fill:#fff;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-3" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            id="path3820"
            className="cls-4"
            d="M7.48,16.4v-1h.17a2.47,2.47,0,0,0,1.78-.81,8.5,8.5,0,0,0,1.75-3.27,10.92,10.92,0,0,1,1.44-2.8A4.54,4.54,0,0,1,14.9,6.85a5.53,5.53,0,0,1,1.47-.27h.15V8.63h-.17A2.82,2.82,0,0,0,15.14,9a4.27,4.27,0,0,0-1.4,1.72c-.12.25-.18.23.76.23h.83V13H12.79l-.14.31a13.45,13.45,0,0,1-1.19,2.12,4.48,4.48,0,0,1-3.31,1.9l-.48,0H7.48v-1Z"
        />
    </svg>
);

export const Doc = (): ReactElement => (
    <svg
        id="doc-docx-icon"
        data-name="Warstwa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden
    >
        <defs>
            <style
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: '#doc-docx-icon .cls-1{fill:#163d75;}#doc-docx-icon .cls-2{fill:#2d4b8e;}#doc-docx-icon .cls-3{fill:#3666ad;}#doc-docx-icon .cls-4{fill:#fff;}#doc-docx-icon .cls-5{fill:#a0bde0;}',
                }}
            />
        </defs>
        <path
            className="cls-1"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            className="cls-2"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            className="cls-1"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path className="cls-3" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path
            className="cls-4"
            d="M5.51,7.43h2.2l1.46,5.86h0l1.91-5.86H13l1.9,6h0l1.53-6h2l-2.68,9.14H14l-2-6.33h0l-2,6.33H8.23Z"
        />
        <polygon className="cls-5" points="18.27 8.17 18.48 7.43 17.52 7.43 18.27 8.17" />
    </svg>
);

export const Img = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
            fill="#0090e0"
            d="M4.7,1A2.09,2.09,0,0,0,2.61,3.13V21.91A2.09,2.09,0,0,0,4.7,24H19.3a2.09,2.09,0,0,0,2.09-2.09V7.3L15.13,1Z"
        />
        <path
            fill="#0abcff"
            d="M4.7,0A2.09,2.09,0,0,0,2.61,2.09V20.87A2.09,2.09,0,0,0,4.7,23H19.3a2.09,2.09,0,0,0,2.09-2.09V6.26L15.13,0Z"
        />
        <polygon
            fill="#0090e0"
            points="21.39 11.3 21.39 10.44 21.39 6.26 18.29 3.16 15.77 5.68 21.39 11.3"
        />
        <path fill="#4addff" d="M21.39,6.26,15.13,0V4.17a2.09,2.09,0,0,0,2.09,2.09Z" />
        <path fill="#fff" d="M8.82,11.66l2.27,2.74,3.18-4.1,4.1,5.46H5.63Z" />
    </svg>
);

export const Loader = (): ReactElement => (
    <svg className="circular loader-icon" viewBox="25 25 50 50" aria-hidden>
        <circle
            className="path"
            cx={50}
            cy={50}
            r={20}
            fill="none"
            stroke="#fff"
            strokeWidth={2}
            strokeMiterlimit={10}
        />
    </svg>
);

export const NewSkinLoader = ({
    width = 28,
    height = 28,
}: {
    width?: number;
    height?: number;
}): ReactElement => (
    <svg
        className="circular loader-icon"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 28 28"
        fill="none"
        style={{ width, height }}
    >
        <path
            d="M16.9313 7.09529C13.1185 5.47683 8.71554 7.25574 7.09708 11.0686C5.47861 14.8815 7.25752 19.2844 11.0704 20.9029L10.0936 23.2041C5.00974 21.0462 2.63787 15.1756 4.79581 10.0918C6.95376 5.00796 12.8244 2.63608 17.9082 4.79403C18.5436 5.06377 18.8401 5.7976 18.5704 6.43308C18.3006 7.06855 17.5668 7.36504 16.9313 7.09529Z"
            fill="url(#paint0_linear_2069_30571)"
        />
        <path
            d="M11.0706 20.9028C14.8835 22.5212 19.2864 20.7423 20.9049 16.9295C22.5233 13.1166 20.7444 8.71364 16.9316 7.09518C16.2961 6.82544 15.9996 6.09161 16.2694 5.45614C16.5391 4.82066 17.2729 4.52418 17.9084 4.79392C22.9922 6.95187 25.3641 12.8225 23.2061 17.9063C21.0482 22.9901 15.1776 25.362 10.0938 23.204L11.0706 20.9028Z"
            fill="url(#paint1_linear_2069_30571)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2069_30571"
                x1="11.0704"
                y1="20.9029"
                x2="17.4198"
                y2="5.94466"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#027AFF" stopOpacity="0.5" />
                <stop offset="1" stopColor="#027AFF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2069_30571"
                x1="17.42"
                y1="5.94455"
                x2="11.0706"
                y2="20.9028"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#027AFF" stopOpacity="0" />
                <stop offset="1" stopColor="#027AFF" stopOpacity="0.5" />
            </linearGradient>
        </defs>
    </svg>
);

export const Alert = (): ReactElement => (
    <svg
        className="alert-icon"
        fill="#000000"
        height={24}
        viewBox="0 0 24 24"
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
    </svg>
);

export const BotsButtonSvg = (): ReactElement => (
    <svg
        className="bots-icon"
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        aria-hidden
    >
        <path fill="none" d="M0,0h24v24H0V0z" />
        <path d="M21.6,10.2l-0.1-1.4c0-2.1-1.6-3.7-3.7-3.8c0,0,0,0,0,0H6.3C4.3,5.1,2.6,6.7,2.6,8.8v1.4H2.4c-1.3,0-2.4,1.1-2.4,2.5v1.7c0,1.3,1.1,2.4,2.4,2.5h1.8v-8c0-1.1,0.9-2,2-2h11.5c1.1,0,2,0.9,2,2V19c0,1.1-0.9,2-2,2h-3.8c-0.3-0.8-1.1-1.2-1.9-1.2c-1.2,0-2.1,0.9-2.1,2.1C9.9,23,10.8,24,12,24c0.8,0,1.6-0.5,1.9-1.2h3.8c2.1,0,3.7-1.6,3.8-3.7c0,0,0,0,0,0v-2.4h0.1c1.3,0,2.4-1.1,2.4-2.4v-1.7C23.9,11.3,22.9,10.2,21.6,10.2z" />
        <circle cx="18.2" cy="2" r="1.7" />
        <circle cx="5.8" cy="2" r="1.7" />
        <path d="M12.2,16.5l2,1.5l2-1.5l0.4-0.2c0.3-0.2,0.4-0.7,0.1-1c-0.2-0.3-0.7-0.4-1-0.1l0,0l-1.5,1.1l-2-1.5l-2,1.5l-1.5-1.1c-0.3-0.2-0.7-0.2-1,0.1c-0.2,0.3-0.2,0.7,0.1,1l2.3,1.7L12.2,16.5z" />
        <circle cx="8.9" cy="11.4" r="1.7" />
        <circle cx="15.1" cy="11.4" r="1.7" />
    </svg>
);

export const DeafultBotIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
            fill="var(--custom-action-color, #0566ff)"
            d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        />
    </svg>
);

export const DeafultStartFlowsIcon = (): ReactElement => (
    <svg
        className="bots-icon"
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
    >
        <path d="M80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v240h-80v-240H160v525l46-45h394v80H240L80-80Zm80-240v-480 480ZM760-40v-200h-80v-240h200l-68 160h88L760-40Z" />
    </svg>
);

export const HistoryIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
    </svg>
);

export const ArrowDown = (): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path d="M7 10L12 15L17 10L7 10Z" />
    </svg>
);

export const SuccessOutlineIcon = (): ReactElement => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#53CF74" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m16.45 9.01-1.19-.96a.2.2 0 0 0-.13-.05.2.2 0 0 0-.14.06l-4.32 5.67-1.75-1.72c-.05-.04-.1-.13-.2-.13s-.14.07-.2.12l-.93 1.02a.95.95 0 0 1-.05.04.22.22 0 0 0-.04.13c0 .05.02.09.04.13l.06.05 3.07 3.01c.05.06.1.12.2.12.08 0 .16-.1.2-.14l5.39-7.08a.22.22 0 0 0 .04-.13c0-.05-.02-.1-.05-.14Z"
            fill="#fff"
        />
    </svg>
);

export const CopyIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5833 15.9166L1.74992 15.9166C0.833252 15.9166 0.083252 15.1666 0.083252 14.2499L0.083252 3.41659L1.74992 3.41659L1.74992 14.2499L12.5833 14.2499V15.9166ZM14.2499 12.5833L5.08325 12.5833C4.16659 12.5833 3.41659 11.8333 3.41659 10.9166L3.41659 1.74992C3.41659 0.833252 4.16659 0.083252 5.08325 0.083252L14.2499 0.083252C15.1666 0.083252 15.9166 0.833252 15.9166 1.74992L15.9166 10.9166C15.9166 11.8333 15.1666 12.5833 14.2499 12.5833ZM14.2499 1.74992L5.08325 1.74992L5.08325 10.9166L14.2499 10.9166L14.2499 1.74992Z"
            fill="#8796AF"
        />
    </svg>
);

export const SuccessOutlineEmptyIcon = (): ReactElement => (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.9999 0.333341C12.2799 0.333342 0.333253 12.28 0.333254 27C0.333256 41.72 12.2799 53.6667 26.9999 53.6667C41.7199 53.6667 53.6666 41.72 53.6666 27C53.6666 12.28 41.7199 0.33334 26.9999 0.333341ZM26.9999 48.3333C15.2399 48.3333 5.66659 38.76 5.66659 27C5.66659 15.24 15.2399 5.66668 26.9999 5.66667C38.7599 5.66667 48.3333 15.24 48.3333 27C48.3333 38.76 38.7599 48.3333 26.9999 48.3333ZM39.2399 15.2133L21.6666 32.7867L14.7599 25.9067L10.9999 29.6667L21.6666 40.3333L42.9999 19L39.2399 15.2133Z"
            fill="#34B857"
        />
    </svg>
);

export const DeleteIcon = (): ReactElement => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.00008 17.8333C7.00008 18.75 7.75008 19.5 8.66675 19.5H15.3334C16.2501 19.5 17.0001 18.75 17.0001 17.8333V7.83333H7.00008V17.8333ZM8.66675 9.5H15.3334V17.8333H8.66675V9.5ZM14.9167 5.33333L14.0834 4.5H9.91675L9.08341 5.33333H6.16675V7H17.8334V5.33333H14.9167Z"
        />
    </svg>
);

export const EyeIcon = (): ReactElement => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Eye">
            <path
                id="Vector"
                d="M8.00016 12C5.4735 12 3.22016 10.58 2.12016 8.33338C3.22016 6.08671 5.47349 4.66671 8.00016 4.66671C10.5268 4.66671 12.7802 6.08671 13.8802 8.33337C12.7802 10.58 10.5268 12 8.00016 12ZM8.00016 13.3334C11.3335 13.3334 14.1802 11.26 15.3335 8.33337C14.1802 5.40671 11.3335 3.33337 8.00016 3.33337C4.66683 3.33337 1.82016 5.40671 0.666829 8.33338C1.82016 11.26 4.66683 13.3334 8.00016 13.3334ZM8.00016 10C7.08016 10 6.3335 9.25337 6.3335 8.33337C6.3335 7.41337 7.08016 6.66671 8.00016 6.66671C8.92016 6.66671 9.66683 7.41337 9.66683 8.33337C9.66683 9.25337 8.92016 10 8.00016 10ZM8.00016 11.3334C9.6535 11.3334 11.0002 9.98671 11.0002 8.33337C11.0002 6.68004 9.6535 5.33337 8.00016 5.33337C6.34683 5.33337 5.00016 6.68004 5.00016 8.33337C5.00016 9.98671 6.34683 11.3334 8.00016 11.3334Z"
                fill="#8796AF"
            />
        </g>
    </svg>
);

export const StarsIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M12.4369 5.67225L11.7846 4.15537L10.2071 3.45761L11.7846 2.77502L12.4369 1.33398L13.0892 2.77502L14.6667 3.45761L13.0892 4.15537L12.4369 5.67225ZM12.4369 14.6977L11.7846 13.2415L10.2071 12.5589L11.7846 11.8763L12.4369 10.3442L13.0892 11.8763L14.6667 12.5589L13.0892 13.2415L12.4369 14.6977ZM5.77782 12.3617L4.38229 9.37342L1.33337 8.00824L4.38229 6.64305L5.77782 3.66997L7.18851 6.64305L10.2223 8.00824L7.18851 9.37342L5.77782 12.3617Z"
            fill="#0566FF"
        />
    </svg>
);

export const InfoIcon = (): ReactElement => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Info">
            <path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.3335 11.3333H8.66683V7.33325H7.3335V11.3333ZM8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM8.00016 13.3333C5.06016 13.3333 2.66683 10.9399 2.66683 7.99992C2.66683 5.05992 5.06016 2.66659 8.00016 2.66659C10.9402 2.66659 13.3335 5.05992 13.3335 7.99992C13.3335 10.9399 10.9402 13.3333 8.00016 13.3333ZM7.3335 5.99992H8.66683V4.66659H7.3335V5.99992Z"
                fill="#0566FF"
            />
        </g>
    </svg>
);

export const SendIcon = (): ReactElement => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="directional-icon"
    >
        <path d="M5.78393 10.7733L3.47785 6.16113C2.36853 3.9425 1.81387 2.83318 2.32353 2.32353C2.83318 1.81387 3.9425 2.36853 6.16113 3.47785L19.5769 10.1857C21.138 10.9663 21.9185 11.3566 21.9185 11.9746C21.9185 12.5926 21.138 12.9829 19.5769 13.7634L6.16113 20.4713C3.9425 21.5806 2.83318 22.1353 2.32353 21.6256C1.81387 21.116 2.36853 20.0067 3.47785 17.788L5.78522 13.1733H12.6367C13.2995 13.1733 13.8367 12.636 13.8367 11.9733C13.8367 11.3105 13.2995 10.7733 12.6367 10.7733H5.78393Z" />
    </svg>
);

export const HomeIcon = (): ReactElement => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            id="home"
            d="M4.66663 24.5V10.5L14 3.5L23.3333 10.5V24.5H16.3333V16.3333H11.6666V24.5H4.66663Z"
            fill="var(--custom-action-color, #0566ff)"
        />
    </svg>
);

export const ChatIcon = (): ReactElement => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="outline"
            d="M3.6001 20.3996V5.17461C3.6001 4.74148 3.75432 4.3707 4.06275 4.06227C4.37119 3.75383 4.74197 3.59961 5.1751 3.59961H18.8251C19.2582 3.59961 19.629 3.75383 19.9374 4.06227C20.2459 4.3707 20.4001 4.74148 20.4001 5.17461V15.6746C20.4001 16.1077 20.2459 16.4785 19.9374 16.787C19.629 17.0954 19.2582 17.2496 18.8251 17.2496H6.7501L3.6001 20.3996ZM6.09385 15.6746H18.8251V5.17461H5.1751V16.5934L6.09385 15.6746Z"
            fill="#647491"
        />
        <path
            className="fill"
            d="M3.6001 20.3996V5.1223C3.6001 4.69595 3.74356 4.33558 4.03048 4.04119C4.31741 3.7468 4.66864 3.59961 5.08417 3.59961H18.916C19.3316 3.59961 19.6828 3.7468 19.9697 4.04119C20.2566 4.33558 20.4001 4.69595 20.4001 5.1223V15.9045C20.4001 16.3308 20.2566 16.6912 19.9697 16.9856C19.6828 17.28 19.3316 17.4272 18.916 17.4272H6.49717L3.6001 20.3996Z"
            fill="var(--custom-action-color, #0566ff)"
        />
    </svg>
);

export const Wave = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 372 15">
        <path
            d="M349.8 1.4C334.5.4 318.5 0 302 0h-2.5c-9.1 0-18.4.1-27.8.4-34.5 1-68.3 3-102.3 4.7-14 .5-28 1.2-41.5 1.6C84 7.7 41.6 5.3 0 2.2v8.4c41.6 3 84 5.3 128.2 4.1 13.5-.4 27.5-1.1 41.5-1.6 33.9-1.7 67.8-3.6 102.3-4.7 9.4-.3 18.7-.4 27.8-.4h2.5c16.5 0 32.4.4 47.8 1.4 8.4.3 15.6.7 22 1.2V2.2c-6.5-.5-13.8-.5-22.3-.8z"
            fill="#fff"
        />
    </svg>
);

export const ChevronDown = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M17.7375 7.36914L19.5 9.13164L12 16.6316L4.5 9.13164L6.2625 7.36914L12 13.0941L17.7375 7.36914Z" />
    </svg>
);

export const ChevronDownLight = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path d="M17.711 7.00046L9.99955 14.7119L2.28809 7.00046L3.40829 5.88025L9.99954 12.4717L16.5908 5.88025L17.711 7.00046Z" />
    </svg>
);

export const ChevronRight = (): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className="directional-icon"
    >
        <path d="M7.5 6.175L8.675 5L13.675 10L8.675 15L7.5 13.825L11.3167 10L7.5 6.175Z" />
    </svg>
);

export const ChevronLeft = (): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="directional-icon"
    >
        <path d="M16.6312 17.7375L14.8687 19.5L7.36865 12L14.8687 4.5L16.6312 6.2625L10.9062 12L16.6312 17.7375Z" />
    </svg>
);

export const ChevronLeftLight = (): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className="directional-icon"
    >
        <path d="M12.9995 17.7115L5.28809 10L12.9995 2.28857L14.1198 3.40878L7.52829 10L14.1198 16.5913L12.9995 17.7115Z" />
    </svg>
);

export const Enter = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10">
        <path
            d="M2.1665 6.25033L4.6665 8.75033L5.25817 8.15866L3.76234 6.66699H8.4165V1.66699H7.58317V5.83366H3.76234L5.25817 4.34199L4.6665 3.75033L2.1665 6.25033Z"
            fill="#647491"
        />
    </svg>
);

export const Lyro = (): ReactElement => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.86458 2.26667C4.49051 2.26667 4.99792 1.75926 4.99792 1.13333C4.99792 0.507411 4.49051 0 3.86458 0C3.23866 0 2.73125 0.507411 2.73125 1.13333C2.73125 1.75926 3.23866 2.26667 3.86458 2.26667Z"
            fill="#0566FF"
        />
        <path
            d="M12.1333 2.26667C12.7593 2.26667 13.2667 1.75926 13.2667 1.13333C13.2667 0.507411 12.7593 0 12.1333 0C11.5074 0 11 0.507411 11 1.13333C11 1.75926 11.5074 2.26667 12.1333 2.26667Z"
            fill="#0566FF"
        />
        <path
            d="M10.8585 10.2612C10.5586 11.5628 9.39266 12.5333 8 12.5333C6.60734 12.5333 5.44136 11.5628 5.1415 10.2612C5.05884 9.90243 5.36514 9.6 5.73333 9.6H10.2667C10.6349 9.6 10.9412 9.90243 10.8585 10.2612Z"
            fill="#0566FF"
        />
        <path
            d="M5.93333 8.53281C6.55926 8.53281 7.06667 8.0254 7.06667 7.39948C7.06667 6.77356 6.55926 6.26615 5.93333 6.26615C5.30741 6.26615 4.8 6.77356 4.8 7.39948C4.8 8.0254 5.30741 8.53281 5.93333 8.53281Z"
            fill="#0566FF"
        />
        <path
            d="M11.201 7.39948C11.201 8.0254 10.6936 8.53281 10.0677 8.53281C9.44179 8.53281 8.93438 8.0254 8.93438 7.39948C8.93438 6.77356 9.44179 6.26615 10.0677 6.26615C10.6936 6.26615 11.201 6.77356 11.201 7.39948Z"
            fill="#0566FF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4 6.60104L14.3333 5.66771C14.3333 4.26771 13.2667 3.20104 11.8667 3.13438H4.13334C2.73334 3.20104 1.66667 4.26771 1.66667 5.66771L1.6 6.60104C0.764178 6.60104 0.0523674 7.2831 0.00275957 8.16884C0.00174825 8.17955 0.000828563 8.19029 1.27157e-06 8.20104L0 9.40104C0 10.2677 0.733334 11.001 1.6 11.0677H1.66667V12.5344C1.73333 13.9344 2.8 15.001 4.2 15.001H11.8C13.2 15.001 14.2667 13.9344 14.3333 12.5344V11.0677H14.4C15.2667 11.001 16 10.2677 16 9.40104L16 8.20104C15.9333 7.33438 15.2667 6.60104 14.4 6.60104ZM11.8 13.801C12.5333 13.801 13.1333 13.201 13.1333 12.4677V5.73438C13.1333 5.00104 12.5333 4.40104 11.8 4.40104H4.2C3.46667 4.40104 2.86667 5.00104 2.86667 5.73438V12.4677C2.86667 13.201 3.46667 13.801 4.2 13.801H11.8Z"
            fill="#0566FF"
        />
    </svg>
);

export const ExpandIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 18.3103L6.05199 14.3623L6.81802 13.5962L9.45832 16.2365V3.76353L6.81802 6.40384L6.05199 5.6378L10 1.68979L13.948 5.6378L13.182 6.40384L10.5417 3.76353L10.5417 16.2365L13.182 13.5962L13.948 14.3623L10 18.3103Z" />
    </svg>
);

export const CollapseIcon = (): ReactElement => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.5417 19.1828L9.45832 19.1828L9.45832 12.0738L6.81802 14.7141L6.05198 13.948L10 10L13.948 13.948L13.182 14.7141L10.5417 12.0738L10.5417 19.1828ZM10 10L6.05198 6.05202L6.81802 5.28598L9.45832 7.92629V0.817251L10.5417 0.817251L10.5417 7.92629L13.182 5.28599L13.948 6.05202L10 10Z" />
    </svg>
);

/* eslint-enable @tidio/rules/always-require-default-export */
